import request from '@/utils/microSeviceFormatRequest'
// import { getAuthUrl } from '@/utils/auth'
export function loginThree () {
  // window.location.href = getAuthUrl()
}
export function loginByUsername () {
  return request({
    url: '/api/account/login',
    method: 'post'
  })
}
export function logout () {
  return request({
    url: '/api/account/logout',
    method: 'get'
  })
}

export function loginLog () {
  return request({
    url: '/api/account/LoginLog',
    method: 'post'
  })
}

export function getUserInfo () {
  return request({
    url: '/api/account/userinfo',
    method: 'get',
    params: { },
    timeout: 3 * 60 * 1000
  })
}

export function getUserMoreInfo () {
    return request({
      url: '/api/account/UserMoreInfo?version=3.0',
      method: 'get',
      params: { },
      timeout: 3 * 60 * 1000
    })
  }
// 找回密码验证邮箱
export function sendVerificationCode (email) {
  return request({
    url: '/api/Account/SendVerificationCode',
    method: 'post',
    data:{Email:email}
  })
}
export function verifyEmailCode (email,code) {
  return request({
    url: '/api/Account/VerifyEmailCode',
    method: 'post',
    data:{Email:email,Code:code}
  })
}

export function verifyTutorInfo (tuid, phone) {
  return request({
    url: '/api/Account/VerifyTutorInfo',
    method: 'post',
    data:{ Tuid:tuid, Phone:phone }
  })
}
export function resetPassword (email,password, code) {
  return request({
    url: '/api/Account/ResetPassword',
    method: 'post',
    data:{Email:email, Password:password, Code: code}
  })
}
export function getTutorAllScore () {
  return request({
    url: '/api/tutordata/TutorAllScore',
    method: 'post'
    // timeout: 60 * 1000
  })
}
// 剩余可兑换鲜花额度
export function getLastFlowerAmount () {
  return request({
    url: '/api/teachInfo/LastFlowerAmount',
    method: 'post'
  })
}
// 自主放课提示按钮
export function getSelfScheduleRemind () {
  return request({
    url: '/api/Account/GetSelfScheduleRemind',
    method: 'post'
  })
}


// 老师修改邮箱 -> 发送邮箱验证码
export function SendChangeEmailVerificationEmail (email) {
  return request({
    url: '/api/Account/SendChangeEmailVerificationEmail',
    method: 'post',
    data:{ Email:email }
  })
}

// 老师修改邮箱
export function ChangeTutorPrivateEmail (email, code, newEmail) {
  return request({
    url: '/api/Account/ChangeTutorPrivateEmail',
    method: 'post',
    data:{ Email:email, Code: code, NewPrivateEmail: newEmail }
  })
}
// 
export function getEntryKey () {
  return request({
    url: '/api/TeachUser/GetEntryKey',
    method: 'post',
  })
}

export function  isFirstShowPoster(){
  return request({
    url: '/api/Account/IsFirstShowPoster',
    method: 'post',
  })
}

//获取用户UI主题 默认0 护眼1
export function tuEyeProtectionMode(){
  return request({
    url: '/api/Account/TuEyeProtectionMode',
    method: 'get',
  })
}

//保存用户选择的UI主题 默认0 护眼1
export function selectEyeProtectionMode(type){
  return request({
    url: `/api/Account/SelectEyeProtectionMode?type=${type}`,
    method: 'post'
  })
}

//获取用户消息总数
export function GetTotalUnreadMessageCount(){
  return request({
    url:'/api/message/GetTotalUnreadMessageCount',
    method: 'post'
  })
}